import {PropsWithChildren} from "react";

import styles from "./SideNavigationToolTip.module.scss";
import {Tooltip, TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger,} from "../../Tooltip";

export interface SideNavigationToolTipProps {
    text: string;
    condition?: boolean;
}

export const SideNavigationToolTip = (
    {
        children,
        text,
        condition = true,
    }: PropsWithChildren<SideNavigationToolTipProps>) => {
    return condition ? (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipPortal>
                    <TooltipContent
                        side={"right"}
                        className={styles.tooltipContent}
                        sideOffset={3}
                        variant={"small"}
                    >
                        {text}
                        <TooltipArrow className={styles.tooltipArrow}/>
                    </TooltipContent>
                </TooltipPortal>
            </Tooltip>
        </TooltipProvider>
    ) : (
        <>{children}</>
    );
};
